import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';
import AdminDiyetisyenler from './AdminDiyetisyenler';
import AdminDiyetisyenDetay from './AdminDiyetisyenDetay';
import AdminPaketler from './AdminPaketler';
import AdminKlinikler from './AdminKlinikler';
import AdminAbonelikler from './AdminAbonelikler';
import Profil from './Profil';
import AdminDestekPanel from './AdminDestekPanel';
import AdminTicketDetay from './AdminTicketDetay';
import AdminIcerikYonetimi from './AdminIcerikYonetimi';

function AdminRoutes({ theme, themePreset, onThemeChange }) {
  return (
    <Routes>
      <Route path="/" element={<AdminDashboard />} />
      <Route path="/diyetisyenler" element={<AdminDiyetisyenler />} />
      <Route path="/diyetisyenler/:diyetisyenId" element={<AdminDiyetisyenDetay />} />
      <Route path="/paketler" element={<AdminPaketler />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/diyetisyenler" element={<AdminDiyetisyenler />} />
      <Route path="/admin/diyetisyenler/:diyetisyenId" element={<AdminDiyetisyenDetay />} />
      <Route path="/admin/paketler" element={<AdminPaketler />} />
      <Route path="/admin/klinikler" element={<AdminKlinikler />} />
      <Route path="/admin/abonelikler" element={<AdminAbonelikler />} />
      <Route path="/admin/karsilama" element={<AdminIcerikYonetimi />} />
      <Route path="/admin/destek" element={<AdminDestekPanel />} />
      <Route path="/admin/destek/ticket/:ticketId" element={<AdminTicketDetay />} />
      <Route path="/profil" element={<Profil theme={theme} themePreset={themePreset} onThemeChange={onThemeChange} />} />
    </Routes>
  );
}
export default AdminRoutes;